<template>
  <div id="app">
    <img src="./assets/logo.png" v-if="false">
    <router-view/>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
export default {
  name: 'App',
  methods: {
    saveStoreItems(){

      window.sessionStorage.setItem("myMenuTree",JSON.stringify(this.getMyMenuTree));
      window.sessionStorage.setItem("loginUser",JSON.stringify(this.getLoginUser));
      window.sessionStorage.setItem("activeMenu",this.getActiveMenu);
      window.sessionStorage.setItem("xtname",this.getXtname);
    }
  },
  computed: {
    ...mapGetters('sys',['getIsCollapse','getMyMenuTree','getLoginUser','getActiveMenu','getXtname'])
  },
  mounted() {
    //监听页面注销
    window.addEventListener('unload',this.saveStoreItems);
    //刷新后设置系统名称
    document.title=this.$store.getters['sys/getXtname'];
  },
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;*/
  color: #2c3e50;
  /*margin-top: 60px;*/
}
</style>



// WEBPACK FOOTER //
// src/App.vue